const filterKeys = ["sportType", "gameType", "gender", "location", "category", "month", "year", "level", "scoresCompletion", "pointsSaved", "playMode", "status", "search", "sortBy", "needingFees"]
const timeframes = ["current", "future", "past", ""]
export const readDirectoryQuery = search => {
  const params = new URLSearchParams(search)
  const requested = params.get("timeframe") === "all" ? "" : params.get("timeframe") || "current"
  const filters = Object.fromEntries(filterKeys.filter(k => params.get(k)).map(k => [k, params.get(k)]))
  if (filters.search) filters.search = filters.search.trim()
  const page = Number(params.get("page")), limit = Number(params.get("limit"))
  const timeframe = filters.search ? "" : timeframes.includes(requested) ? requested : "current"
  const previous = params.get("returnTimeframe")
  return { filters, timeframe, options: { page: Number.isSafeInteger(page) && page > 0 ? page : 1, limit: [15,25,50].includes(limit) ? limit : 15 },
    returnTimeframe: previous === "all" ? "" : timeframes.includes(previous) ? previous : requested }
}
export const writeDirectoryQuery = ({ filters, options, timeframe, returnTimeframe }) => {
  const params = new URLSearchParams()
  if (timeframe !== "current") params.set("timeframe", timeframe || "all")
  Object.keys(filters).sort().forEach(k => { if (filters[k]) params.set(k, filters[k]) })
  // A search and the events needing fees span all dates; leaving them returns to the dates shown before.
  if (filters.search || filters.needingFees) params.set("returnTimeframe", returnTimeframe || "all")
  if (options.page > 1) params.set("page", String(options.page))
  if (options.limit !== 15) params.set("limit", String(options.limit))
  return params.toString() ? "?" + params : ""
}
export const rememberEventDirectory = search => { try { sessionStorage.setItem("eventDirectorySearch", search) } catch (error) { /* Storage is optional. */ } }
export const eventDirectoryLocation = () => {
  let search = ""
  try { search = sessionStorage.getItem("eventDirectorySearch") || "" } catch (error) { /* Default to Current. */ }
  return { pathname: "/events-management", search: writeDirectoryQuery(readDirectoryQuery(search)) }
}
